import { ArrowRight } from "lucide-react";
import { Link } from "@tanstack/react-router";

import { Card, CardContent } from "@/components/ui/card";
import { trackEvent } from "./analytics";
import { PROBLEMS } from "./problems";

/**
 * The six "start with your problem" cards - the heart of the solution-led
 * message.
 *
 * Every card now links to its own section on `/solutions`, which is the page
 * these links were waiting for. They previously anchored to `#book`, the booking
 * CTA: the label promised an explanation and delivered a request for a call,
 * which is the bait these cards exist to avoid, so they were removed on
 * 2026-08-02 until there was somewhere real to send a reader.
 *
 * The copy and the link targets both live in `problems.ts`, shared with
 * `/solutions` - so the anchor a card points at is the same string the section
 * renders as its `id`, and neither page can drift from the other.
 */
export function ProblemCards() {
  return (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
      {PROBLEMS.map((problem) => (
        <Card key={problem.id} className="flex flex-col bg-slate-50">
          <CardContent className="flex flex-1 flex-col gap-3 space-y-0 p-7">
            <h3 className="text-lg font-bold text-brand-blue-dark">
              {problem.title}
            </h3>
            <p className="italic text-slate-500">“{problem.quote}”</p>
            <p className="text-slate-600">{problem.answer}</p>
            <Link
              to="/solutions"
              hash={problem.id}
              onClick={() => trackEvent("problem_card", problem.id)}
              className="mt-auto inline-flex items-center gap-1 pt-2 font-semibold text-brand-blue-dark hover:underline"
            >
              See the solution
              <ArrowRight className="h-4 w-4" aria-hidden="true" />
            </Link>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
